import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to console in development
        if (process.env.NODE_ENV === 'development') {
            console.error('Error caught by boundary:', error, errorInfo);
        }
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-black">
                    <div className="bg-black p-8 rounded-lg shadow-md text-white max-w-lg">
                        <h2 className="text-2xl font-semibold mb-4">Something went wrong</h2>
                        <p className="mb-4">We apologize for the inconvenience. Please try refreshing the page.</p>
                        {process.env.NODE_ENV === 'development' && (
                            <details className="mt-4">
                                <summary className="cursor-pointer text-gray-400">Error Details</summary>
                                <pre className="mt-2 p-4 bg-gray-900 rounded text-sm overflow-auto">
                                    {this.state.error && this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                        <button
                            onClick={() => window.location.reload()}
                            className="mt-4 px-4 py-2 bg-white text-black rounded hover:bg-gray-200 transition-colors"
                        >
                            Refresh Page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 